import axiosInstance from './axios';

// Увеличивает счетчик просмотра объявления на единицу
async function postContactsViewed(advertId) {
  const config = {
    method: 'POST',
    url: `/public/api/v1/transports/contacts_viewed/${advertId}`,
  };

  const res = await axiosInstance(config);
  return res.data;
}

export default postContactsViewed;
